module.exports = __webpack_public_path__ + "images/category_lp/watch/seiko/assessment_achievements/5_010b8471b7270610c7d8786ac0e33d95.png";